app.service('order', function (main, front, paymentView, deliveryView, deliveryTime, loginView, finalizeView, basketView, notIssuedOrderView, obligatoryChangePassword){
	$(document).on('pageChange', function() {
		run();
	});
	function setElements() {

	}
	function run(){
		switch(front.page()) {
			case 'payment':
				paymentView.init();
				break;
			case 'delivery-time':
				deliveryTime.init();
				break;
			case 'order-finalize':
				finalizeView.init();
				break;
			case 'basket':
				basketView.init();
				break;
			case 'not-issued-order':
				notIssuedOrderView.init();
				break;
			case 'delivery':
				deliveryView.init();
				break;
			case 'obligatory-change-password':
				obligatoryChangePassword.init();
				break;
			case 'accountLogin':
				
			case 'login':
				loginView.init();
			default:
				break;
		}
	}
	function setEvents() {
		run();
	}
	function init(){
		setElements();
		setEvents();
	}
	main.onLoad(init);
});
